export default __webpack_public_path__ + "static/media/alertCircle.63ebe04b.svg";